import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Promo code {{code}} angewandt',
  [COUPON_TYPES.CASHBACK]: 'Loyalty Punkte angewandt',
  [COUPON_TYPES.REWARD]: 'Reward angewandt',
};

export default Coupons;
